import Timer from 'easytimer.js'

export const initCountdowns = () => {
    const lang = document.querySelector('html').getAttribute('lang')

    import(`../locale/${lang}`).then(module => {
        const locale = module.default.Countdown

        const getSeconds = (date, limitToEndOfMonth = false) => {
            const now = new Date();

            if (limitToEndOfMonth) {
                const targetYear = date.getFullYear();
                const targetMonth = date.getMonth();
                const currentYear = now.getFullYear();
                const currentMonth = now.getMonth();

                if ((targetYear > currentYear) || (targetYear === currentYear && targetMonth > currentMonth)) {
                    // Last day of current month at 23:59:59
                    const endOfMonth = new Date(currentYear, currentMonth + 1, 0, 23, 59, 59);
                    const difference = (endOfMonth - now) / 1000;
                    return { seconds: difference };
                }
            }

            const difference = (date - now) / 1000;
            return { seconds: difference };
        }

        const getHtml = (value, label, showDivider = true) => {
            let template = `<span class="is-value">${value}${label}</span>`

            if (showDivider === 'space') {
                template += `<span class="is-space"></span>`
            }
            else if (showDivider) {
                template += `<span class="is-divider">:</span>`
            }

            return template
        }

        const getString = timer => {
            const values = timer.getTimeValues(),
                days = values.days > 0 ? getHtml(values.days, locale.days) : '',
                hours = values.days > 0 || values.hours > 0 ? getHtml(values.hours, locale.hours) : '',
                minutes = values.days > 0 || values.hours > 0 || values.minutes > 0 ? getHtml(values.minutes, locale.minutes, 'space') : '',
                seconds = values.days > 0 || values.hours > 0 || values.seconds > 0 ? getHtml(values.seconds.toString().padStart(2, '0'), locale.seconds, false) : ''

            return `${days}${hours}${minutes}${seconds}`
        }

        for (const countdown of document.querySelectorAll('.js-countdown')) {
            if (countdown.classList.contains('is-countdown-initialized')) continue

            const date = new Date(countdown.dataset.time),
                limitToEndOfMonth = countdown.dataset.limitMonth === 'true',
                timer = new Timer({ countdown: true })

            timer.start({ startValues: getSeconds(date, limitToEndOfMonth) })

            timer.addEventListener('secondsUpdated', function (e) {
                countdown.innerHTML = getString(timer)
            })

            timer.addEventListener('targetAchieved', function (e) {
                countdown.innerHTML = ''
            })

            countdown.classList.add('is-countdown-initialized')
        }
    })
}
